import { Wordmark } from '@repo/ui';

/**
 * 좁은 화면에서 에디터 대신 보여주는 안내.
 *
 * 에디터 셸은 `h-screen` 고정 2열(9:16 프리뷰 + 타임라인)에 드래그로 구간을
 * 잡는 구조라 폰 폭에서는 우측 컬럼과 헤더 버튼이 통째로 화면 밖으로 나간다.
 * 반응형으로 접는 대신, 왜 안 되는지와 무엇을 하면 되는지를 알려 준다.
 *
 * 현재 URL 에는 `#at=<accessToken>` 이 붙어 있으므로 **주소를 화면에 노출하거나
 * 복사시키지 않는다.** 대신 대시보드에서 다시 여는 경로를 안내한다.
 */
export default function MobileNotice() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-6 bg-background px-6 py-12 text-center">
      <Wordmark className="h-8" />
      <div className="space-y-3">
        <h1 className="text-lg font-semibold text-foreground">편집기는 PC에서 열어주세요</h1>
        <p className="max-w-sm text-sm leading-relaxed text-muted-foreground">
          타임라인과 미리보기를 나란히 놓고 다뤄야 해서 넓은 화면이 필요합니다. 노트북이나
          데스크탑에서 스트리머 대시보드에 접속한 뒤{' '}
          <span className="text-foreground">하이라이트 편집</span>을 다시 눌러주세요.
        </p>
      </div>
      <p className="text-xs text-muted-foreground">편집 중이던 내용은 그대로 남아 있습니다.</p>
    </div>
  );
}
